<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
	<circle cx="13" cy="13" r="12.5" [attr.fill]="color1"/>
	<path d="M8.54102 14.2085L11.3743 17.0418L18.4577 9.9585" [attr.stroke]="color2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
